import { Reducer } from "use-immer"

export enum ACTIONS {
    FETCH_SNAPSHOT_REQUEST = "FETCH_SNAPSHOT_REQUEST",
    FETCH_SNAPSHOT_SUCCESS = "FETCH_SNAPSHOT_SUCCESS",
    FETCH_SNAPSHOT_FAILURE = "FETCH_SNAPSHOT_FAILURE",
    FETCH_REPORT_REQUEST = "FETCH_REPORT_REQUEST",
    FETCH_REPORT_SUCCESS = "FETCH_REPORT_SUCCESS",
    FETCH_REPORT_FAILURE = "FETCH_REPORT_FAILURE",
    FETCH_CLAIMSTATUS_REQUEST = "FETCH_CLAIMSTATUS_REQUEST",
    FETCH_CLAIMSTATUS_SUCCESS = "FETCH_CLAIMSTATUS_SUCCESS",
    FETCH_CLAIMSTATUS_FAILURE = "FETCH_CLAIMSTATUS_FAILURE",
    CLAIM_WEEKS_REQUEST = "CLAIM_WEEKS_REQUEST",
    CLAIM_WEEKS_SUCCESS = "CLAIM_WEEKS_SUCCESS",
    CLAIM_WEEKS_FAILURE = "CLAIM_WEEKS_FAILURE",
}

interface ActionType {
    type: ACTIONS
    payload?: any
}

export interface SnapshotWeekly {
    timestamp: number
    hash: string
    weekNumber: number
    totalRewardPerp: number
}

export interface LatestWeek {
    [key: string]: number
}

export type Report = Record<string, string>

interface StateType {
    isLoading: boolean
    isInitialized: boolean
    isError: boolean
    latestWeek: LatestWeek
    report: Record<string, Report[]>
    snapshot: Record<string, Record<string, SnapshotWeekly>>
    claimStatus: Record<string, boolean[]>
    failedTxIds: string[]
    pendingTxIds: string[]
}

export const initialState: StateType = {
    isLoading: false,
    isInitialized: false,
    isError: false,
    latestWeek: {},
    report: {},
    snapshot: {},
    claimStatus: {},
    failedTxIds: [],
    pendingTxIds: [],
}

export const reducer: Reducer<StateType, ActionType> = (draft, action) => {
    switch (action.type) {
        case ACTIONS.FETCH_SNAPSHOT_REQUEST: {
            draft.isLoading = true
            break
        }
        case ACTIONS.FETCH_SNAPSHOT_SUCCESS: {
            const { snapshot, latestWeek } = action.payload
            draft.snapshot = snapshot
            draft.latestWeek = latestWeek
            draft.isLoading = false
            break
        }
        case ACTIONS.FETCH_SNAPSHOT_FAILURE: {
            draft.isLoading = false
            draft.isError = true
            break
        }
        case ACTIONS.FETCH_REPORT_REQUEST: {
            draft.isLoading = true
            break
        }
        case ACTIONS.FETCH_REPORT_SUCCESS: {
            const { report } = action.payload
            draft.report = report
            draft.isLoading = false
            draft.isInitialized = true
            break
        }
        case ACTIONS.FETCH_REPORT_FAILURE: {
            draft.isLoading = false
            draft.isError = true
            break
        }
        case ACTIONS.CLAIM_WEEKS_REQUEST: {
            const { tx } = action.payload
            draft.pendingTxIds.push(tx)
            break
        }
        case ACTIONS.CLAIM_WEEKS_SUCCESS: {
            const { tx } = action.payload
            const idx = draft.pendingTxIds.findIndex(_tx => tx === _tx)
            draft.pendingTxIds.splice(idx, 1)
            break
        }
        case ACTIONS.CLAIM_WEEKS_FAILURE: {
            const { tx } = action.payload
            const idx = draft.pendingTxIds.findIndex(_tx => tx === _tx)
            draft.pendingTxIds.splice(idx, 1)
            draft.failedTxIds.push(tx)
            break
        }
        case ACTIONS.FETCH_CLAIMSTATUS_REQUEST: {
            draft.isLoading = true
            break
        }
        case ACTIONS.FETCH_CLAIMSTATUS_SUCCESS: {
            const { claimStatus } = action.payload
            draft.claimStatus = claimStatus
            draft.isLoading = false
            break
        }
        case ACTIONS.FETCH_CLAIMSTATUS_FAILURE: {
            draft.isLoading = false
            draft.isError = true
            break
        }
    }
}
